import ReactDOM from "react-dom";
import React from "react";
import { ModalContainer, ModalOverlay } from "../modal/CustomDetailModal";
import { Theme } from "../../Theme";
import { ContentWrapperMenuItems } from "../content_wrapper/ContentWrapperComponents";
import { Column, Row, SizedBox } from "../CommonBaseComponents";
import CustomIcon from "../image/CustomIcon";
import { C3Text } from "../text/CustomText";
import Translate from "../../translate/Translate";

const GnbSidebar = ({
    title,
    isOpen,
    onClose,
    children,
    width,
    side = "left",
    contentPadding = "20px 20px",
    maxWidth,
    height,
    bottomButtons,
    isCloseIfOutside = true,
    paddingRight,
    overlayColor = Theme.color.black_025,
    alignItems = "center",
    paddingTop,
    allowContentScroll = true,
}) => {
    if (!isOpen) {
        return null;
    }

    return ReactDOM.createPortal(
        <ModalOverlay
            onClick={isCloseIfOutside ? onClose : () => {}}
            side={side}
            paddingLeft={"0"}
            $overlayColor={overlayColor}
            alignItems={alignItems}
        >
            <ModalContainer
                onClick={(e) => e.stopPropagation()}
                width={"280px"}
                height={"100%"}
                maxWidth={maxWidth}
                maxHeight={"100vh"}
                $borderTopLeftRadius={"0"}
                $borderBottomLeftRadius={"0"}
            >
                <Column alignItem={"flex-start"} padding={"12px"}>
                    <SizedBox height={"24px"} />
                    <Row>
                        <SizedBox width={"6px"} />
                        <CustomIcon iconName={"logo"} size={"32px"} />
                        <SizedBox width={"10px"} />
                        <C3Text fontWeight={"800"} letterSpacing={"-0.02rem"}>
                            {Translate("common.laundryCrew")} {Translate("role.admin")}
                        </C3Text>
                    </Row>
                    <SizedBox height={"24px"} />
                    <ContentWrapperMenuItems />
                </Column>
            </ModalContainer>
        </ModalOverlay>,
        document.getElementById("modal-root")
    );
};

export default GnbSidebar;
